import axios from "axios";

export const fileDownload = {
  methods: {
    async triggerFileDownload(url, name) {
      let isSuccess = false;
      await axios({
        url:
          process.env.VUE_APP_API_URL +
          url,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", name);
        document.body.appendChild(fileLink);

        fileLink.click();
        isSuccess = true;
      }).catch(() => {
        this.$store.dispatch("notification/triggerError", { detail: "We were unable to download this file" });
      });

      return isSuccess;
    }
  }
}
